import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
const Payment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const tabs = [
    { label: 'Overview', value: 'overview' },
    // { label: 'Usage & Cost', value: 'usage' },
    { label: 'Invoice', value: 'invoice' },
    { label: 'Balance History', value: 'balance-history' },
    { label: 'Credit', value: 'credit' },
  ];

  const currentTab = location.pathname.split('/').pop() || 'overview';
  const handleTabChange = (value: string) => {
    navigate(value);
  };

  return (
    <div className="container flex flex-col gap-3">
      <p className="text-xl font-semibold">Payment</p>
      <div>
        <Tabs
          value={currentTab}
          onValueChange={handleTabChange}
          className="w-full"
        >
          <TabsList variant="outline" className="mb-8">
            {tabs.map((tab) => (
              <TabsTrigger key={tab.value} value={tab.value} variant="outline">
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>
        <Outlet />
      </div>
    </div>
  );
};

export default Payment;
